const initialState = {
  providerSearchTerm: '',
  specialtySearchTerm: '',
  isFetchingSavedFacilities: false,
  isFetchingSavedProviders: false,
  isSettingSavedProvider: false,
  savedFacilities: [],
  savedProviders: [],
  hasFetchedSavedProviders: false,
  infoWindowContent: null,
  infoWindowPaginationPage: 1,
  activeMarkerCoordinates: null,
  errorFetchingSavedFacilities: null,
  errorFetchingSavedProviders: null,
  errorSavingFacility: null,
  errorSavingProvider: null,
  errorDeletingSavedProvider: null,
};

export default initialState;
